{
    "coordinates": [
        50.753815598246405,
        -111.47594943687538
    ],
    "tooltip": "Dinosaur Park",
    "title": "Dinosaur Park Formation",
    "country": "Canada",
    "period": "Cretaceous",
    "alt": "TODO"
}